// extracted by mini-css-extract-plugin
export default {"tab":"ClientManagementDetail_tab__48P9I"};